import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-800/30 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <span className="w-16 h-16 flex items-center justify-center mx-auto text-foreground-600">
          <i className="ri-emotion-sad-line text-5xl"></i>
        </span>
        <h1 className="text-xl md:text-2xl font-bold text-foreground-200 mt-6 font-heading">
          页面未找到
        </h1>
        <p className="mt-2 text-sm text-foreground-600 font-mono">
          {location.pathname}
        </p>
        <p className="mt-4 text-sm text-foreground-500">
          你访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-950 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-all"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}